import type { Segment } from './segments.js';

/**
 * Mapping codes NAF (rev2) → segment SEF.
 * Source : nomenclature INSEE NAF rév. 2 (2008).
 * Décision auto-détection : on matche le préfixe à 2 caractères, fallback "pro".
 */
export const NAF_PREFIX_TO_SEGMENT: Record<string, Segment> = {
  '01': 'agri',
  '02': 'agri',
  '03': 'agri',
  '94': 'asso',
  '68': 'syndic',
};

export function nafToSegment(nafCode: string | null | undefined): Segment {
  if (!nafCode) return 'inconnu';
  const prefix = nafCode.slice(0, 2);
  return NAF_PREFIX_TO_SEGMENT[prefix] ?? 'pro';
}

export function nafToSegmentFromEffectif(
  nafCode: string | null | undefined,
  effectifTranche: string | null | undefined,
): Segment {
  const base = nafToSegment(nafCode);
  if (base !== 'pro') return base;
  if (!effectifTranche) return 'pro';
  const code = parseInt(effectifTranche, 10);
  if (Number.isFinite(code) && code >= 22) return 'entreprise';
  return 'pro';
}
